Ext.define('SA.model.DatasetCensusRelease', {
    constructor({censusReleaseYear, latestEdition, editions}) {
        this.censusReleaseYear = censusReleaseYear;
        this.latestEdition = latestEdition;
        this.editions = editions;
    },

    getEditions() {
        return this.editions;
    },

    getLatestEdition() {
        return this.latestEdition;
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.censusReleaseYear === censusReleaseYear;
    },

    hasEdition(edition) {
        return this.editions.includes(edition);
    }
});